// Scroll to top of site when switching pages

import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/* When Switching pages, this function brings up to the top of the new page
regardless of where we were on the prior page */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); 
  }, [pathname]);

  return null;
};

export default ScrollToTop;